module.exports = __webpack_public_path__ + "static/media/steel-production.428df1e6.png";